import React, { ReactNode, useState } from "react";

type SubmitProps = {
  onClick: any;
  children?: ReactNode;
  className?: any;
  disabled?: boolean;
};

const OutlinedButton = (props: SubmitProps) => {
  return (
    <button
      type="button"
      className={`button outlined ${props.className ?? ""}`}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <div className="text">{props.children}</div>
    </button>
  );
};

export default OutlinedButton;
